import { messageActions, NotificationLink } from "../features/message/messageSlice";
import { useAppDispatch } from "../app/hooks";
import { translate } from "../features/messaging/helpers";

const useNotification = () => {
  const { setNotification, unsetNotification } = messageActions;
  const dispatch = useAppDispatch();

  const sendNotification = (
    title: string,
    text: string,
    confirmText?: string,
    links?: Record<string, NotificationLink>,
  ) => {
    dispatch(
      setNotification({
        title: translate(title),
        text: translate(text),
        confirmText: confirmText ? translate(confirmText) : undefined,
        links,
      }),
    );
  };

  const wipeNotification = () => {
    dispatch(unsetNotification());
  };

  return {
    sendNotification,
    wipeNotification,
  };
};

export default useNotification;
